export enum UserRole {
  ROLE_COMPANY,
  ROLE_USER,
  ROLE_COMPANY_ADMIN,
}
